import * as React from 'react';
import Figure from '../Figure';
import Markdown from '../Markdown';
export var TableCellType;
(function (TableCellType) {
    TableCellType["Text"] = "Text";
    TableCellType["Image"] = "Image";
})(TableCellType || (TableCellType = {}));
function calculateWidth(headers) {
    let width = 0;
    headers.forEach(h => {
        width += parseInt(h.width || '0', 10);
    });
    return width;
}
export default function Table({ headers, data, width }) {
    const tableWidth = width ? parseInt(width, 10) : calculateWidth(headers);
    const style = { width: tableWidth };
    return (React.createElement("table", { className: "center collapse ba br2 b--black-10 pv2 ph3", style: style },
        React.createElement("thead", null,
            React.createElement("tr", { className: "bg-gray near-white" }, headers.map(({ theme = {}, ...item }, idx) => (React.createElement("th", { className: theme.header, key: idx, style: { width: item.width } }, item.title))))),
        React.createElement("tbody", null, data.map((row, idx) => (React.createElement("tr", { key: idx, className: "striped--light-gray" }, row.map((cell, subIdx) => {
            const { type = TableCellType.Text, theme = {} } = headers[subIdx];
            switch (type) {
                case TableCellType.Text:
                    return (React.createElement("td", { className: theme.cell, key: subIdx },
                        React.createElement(Markdown, { source: cell })));
                case TableCellType.Image:
                    return (React.createElement("td", { className: theme.cell, key: subIdx },
                        React.createElement(Figure, { image: cell })));
                default:
                    return null;
            }
        })))))));
}
//# sourceMappingURL=index.js.map